require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-basic-styles-sandbox-eventbrite-test.json") })
        }
      }, "path---es-basic-styles-sandbox-eventbrite-test");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-basic-styles-sandbox-eventbrite-test!./.cache/json/es-basic-styles-sandbox-eventbrite-test.json
// module id = 2490
// module chunks = 231608221292675